import Cookies from 'js-cookie';
import { cookiesDomain } from '../settings';

type Set = (key: string, value: string, setToCookie?: boolean, setToLocalStorage?: boolean) => void;
type Get = (key: string) => string | null;
type Remove = (key: string, removeFromCookie?: boolean) => void;
type RemoveAll = () => void;

/** Klasa zawiera metody służące zapisywaniu danych do localStorage oraz cookies */
class StorageManager {
  /** Zapisz dane */
  set: Set = (key, value, setToCookie = false, setToLocalStorage = true) => {
    if (setToLocalStorage) {
      localStorage.setItem(key, value);
    }
    if (setToCookie) {
      Cookies.set(key, value, { path: '/', domain: cookiesDomain });
    }
  };
  /** Pobierz dane */
  get: Get = key => {
    const valueLocalStorage: string | null = localStorage.getItem(key);
    const valueCookies: string | undefined = Cookies.get(key);
    if (valueLocalStorage) return valueLocalStorage;
    else if (valueCookies) return valueCookies;
    else return null;
  };
  /** Usuń dane */
  remove: Remove = (key, removeFromCookie = true) => {
    localStorage.removeItem(key);
    if (removeFromCookie) {
      Cookies.remove(key, { path: '/', domain: cookiesDomain });
    }
  };
  /** Usuń wszystkie dane */
  clear: RemoveAll = () => {
    localStorage.clear();
    Cookies.remove('id_token', { path: '/', domain: cookiesDomain });
    Cookies.remove('refresh_token', { path: '/', domain: cookiesDomain });
  };

  clearTokens: RemoveAll = () => {
    localStorage.removeItem('id_token');
    localStorage.removeItem('refresh_token');
    Cookies.remove('id_token', { path: '/', domain: cookiesDomain });
    Cookies.remove('refresh_token', { path: '/', domain: cookiesDomain });
  };
}

export default new StorageManager();
